import { AlertTriangle, CheckCircle, Clock, XCircle } from "lucide-react";

const ApprovalsSection = ({ ctx }) => {
  const {
    canApprove,
    handleRejectInward,
    materials,
    pendingApprovals,
    requirements,
    setApprovalDialogOpen,
    setApprovalRemarks,
    setSelectedInward
  } = ctx;
  return (
    <>
        <div className="space-y-4">
          {!canApprove && (
            <div className="bg-amber-50 border border-amber-200 rounded-sm p-4 flex items-center">
              <AlertTriangle className="w-5 h-5 text-amber-600 mr-3" />
              <p className="text-amber-800">Only Management/Project Director/Project Manager can approve material inward entries.</p>
            </div>
          )}
          
          {pendingApprovals.length === 0 ? (
            <div className="stat-card text-center py-12">
              <CheckCircle className="w-16 h-16 mx-auto mb-4 text-success" />
              <h3 className="text-lg font-medium text-slate-700">No Pending Approvals</h3>
              <p className="text-slate-500 mt-2">All material inward entries are approved.</p>
            </div>
          ) : (
            <div className="grid gap-4">
              {pendingApprovals.map((record) => {
                const material = materials.find(m => m.id === record.material_id);
                const req = requirements.find(r => r.id === record.material_requirement_id);
                
                return (
                  <div key={record.id} className="stat-card border-l-4 border-warning">
                    <div className="flex items-start justify-between">
                      <div>
                        <div className="flex items-center space-x-3">
                          <span className="font-mono text-sm font-medium text-primary">{record.grn_number}</span>
                          <span className="px-2 py-1 bg-warning/10 text-warning text-xs font-medium rounded-sm flex items-center">
                            <Clock className="w-3 h-3 mr-1" />
                            Pending Approval
                          </span>
                        </div>
                        <h3 className="font-medium text-lg mt-2">{material?.name || "Unknown Material"}</h3>
                        <p className="text-sm text-slate-500">{record.date} | Supplier: {record.supplier_name}</p>
                      </div>
                      <div className="text-right">
                        <p className="font-mono text-2xl font-bold text-primary">{record.quantity}</p>
                        <p className="text-sm text-slate-500">{material?.unit || "units"}</p>
                      </div>
                    </div>
                    
                    <div className="mt-4 space-y-2">
                      {record.requires_rate_approval && (
                        <div className="flex items-center text-sm text-error bg-error/5 p-2 rounded-sm">
                          <AlertTriangle className="w-4 h-4 mr-2" />
                          <span>
                            <strong>Rate Variance:</strong> Entered ₹{record.entered_rate} vs Stock Register ₹{record.stock_register_rate || materials.find(m => m.id === record.material_id)?.rate || 0} 
                            ({record.rate_variance_percent > 0 ? '+' : ''}{record.rate_variance_percent?.toFixed(1)}% variance, allowed ±3%)
                          </span>
                        </div>
                      )}
                      {record.requires_quantity_approval && (
                        <div className="flex items-center text-sm text-error bg-error/5 p-2 rounded-sm">
                          <AlertTriangle className="w-4 h-4 mr-2" />
                          <span>
                            <strong>Quantity Exceeds:</strong> Inward quantity exceeds remaining requirement.
                          </span>
                        </div>
                      )}
                    </div>
                    
                    <div className="mt-4 pt-4 border-t border-slate-200 flex items-center justify-between">
                      <div className="text-sm text-slate-500">
                        Challan: {record.challan_number} | Vehicle: {record.vehicle_number}
                      </div>
                      {canApprove && (
                        <div className="flex space-x-2">
                          <button
                            onClick={() => { setSelectedInward(record); setApprovalRemarks(""); setApprovalDialogOpen(true); }}
                            className="btn-primary text-sm py-1 px-3 flex items-center"
                          >
                            <CheckCircle className="w-4 h-4 mr-1" />
                            Review
                          </button>
                          <button
                            onClick={() => handleRejectInward(record.id, "Rejected without review")}
                            className="btn-outline text-error border-error hover:bg-error/10 text-sm py-1 px-3 flex items-center"
                          >
                            <XCircle className="w-4 h-4 mr-1" />
                            Reject
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
    </>
  );
};

export default ApprovalsSection;
